"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _isDateString = _interopRequireDefault(require("./isDateString"));

var _default = function _default(date) {
  if ((0, _isDateString.default)(date)) {
    return _I18n.default.moment(date, 'MM-DD-YYYY');
  }

  return _I18n.default.moment(date);
};

exports.default = _default;
module.exports = exports.default;